module.exports = __webpack_public_path__ + "img/staff-1991-jinhaihu.b97b35e2.jpg";